import { render, staticRenderFns } from "./OnboardingBanner.vue?vue&type=template&id=a03d9cd0&"
import script from "./OnboardingBanner.vue?vue&type=script&lang=js&"
export * from "./OnboardingBanner.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingBanner.vue?vue&type=style&index=0&id=a03d9cd0&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports
import {QIcon,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QIcon,QBtn})
